import { confirm } from '@/notifications'

/**
 * Modals raised from places with no component instance, such as the axios
 * interceptor in the auth store. Everything here resolves to a boolean:
 * true when the user took the primary action.
 */
export default {
    contentMap: {
        mission_control_user_limit: {
            title: 'Mission Control User Limit',
            copy:
                'You have hit your Mission Control user limit of %limit%. To give this user Mission Control ' +
                'permissions, disable the permissions of another user, or upgrade your organization below.',
        },
        pli_limit: {
            title: 'User View Limit',
            copy:
                'You have hit your view limit of %limit% users. To view the location of the user(s) you ' +
                'selected, hide a user that is currently shown, or upgrade your organization below.',
        },
    },

    /**
     * @param {string} type a key of contentMap
     * @param {number} limit
     * @returns {Promise<boolean>} true when the user chose to upgrade
     */
    paywallError(type, limit) {
        return confirm({
            header: this.contentMap[type].title,
            message: this.contentMap[type].copy.replace(/%limit%/g, limit),
            acceptLabel: 'Upgrade',
            rejectLabel: 'Ok',
        })
    },

    /**
     * @param {string} copy
     * @returns {Promise<boolean>}
     */
    genericError(copy) {
        return confirm({
            header: 'Error',
            message: copy,
            acceptLabel: 'OK',
            // Nothing to decline; the user can only acknowledge it.
            rejectLabel: null,
        })
    },

    /**
     * @param {object} config passed straight through to the confirmation
     * @returns {Promise<boolean>}
     */
    GenericMessage(config) {
        return confirm({ acceptLabel: 'Continue', ...config })
    },
}
